$ ->
  $(document).on 'click', '[data-behaviour="trigger-click"]', (ev) ->
    ev.preventDefault()
    $($(@).data('view')).click()
